<script lang="ts">
    import LanguageSelection from '$lib/components/navigation/LanguageSelection.svelte';
    import FairAndGreenLogoImg from '$lib/assets/images/logos/fairandgreen-logo.png?as=run:0&format=avif;webp;png&w=89';
    import VDPLogoImg from '$lib/assets/images/logos/vdp-logo.png?as=run:0&format=avif;webp;png&w=38';
    import SlowFoodLogoImg from '$lib/assets/images/logos/slowfood-logo.png?as=run:0&format=avif;webp;png&w=67';
    import HeartIcon from '$lib/assets/icons/HeartIcon.svelte';
    import { useLocaleContext } from '$lib/context';
    import { t } from 'svelte-i18n';
    import Img from '@zerodevx/svelte-img';

    const lang = useLocaleContext();
    const currentYear = new Date().getFullYear();

    export let paymentMethods;
</script>

<div class="w-full bg-black lg:flex justify-center text-neutral-500 font-jost tracking-wide">
    <div class="w-full max-w-screen-2xl lg:my-6 px-5">
        <div
            class="border-b border-neutral-700 justify-between pb-8 pt-8 lg:pt-2 flex flex-col lg:flex-row gap-8 lg:gap-0"
        >
            <a href="https://www.fairandgreen.com/" target="_blank" class="flex items-center gap-5 group">
                <div class="shrink-0 w-[4.438rem] flex justify-center">
                    <Img src={FairAndGreenLogoImg} alt="Fair and Green e.V. Logo" />
                </div>
                <h2 class="group-hover:text-neutral-300 transition-colors">Fair and Green e.V.</h2>
            </a>

            <a href="https://www.vdp.de/" target="_blank" class="flex items-center gap-5 group">
                <div class="shrink-0 w-[4.438rem] flex justify-center">
                    <Img src={VDPLogoImg} alt="VDP. Logo" />
                </div>
                <h2 class="group-hover:text-neutral-300 transition-colors">
                    VDP. Verband deutscher Prädikatsweingüter
                </h2>
            </a>

            <a href="https://www.slowfood.de/" target="_blank" class="flex items-center gap-5 group">
                <div class="shrink-0 w-[4.438rem] flex justify-center">
                    <Img src={SlowFoodLogoImg} alt="Slow Food Deutschland e.V. Logo" />
                </div>
                <h2 class="group-hover:text-neutral-300 transition-colors">Slow Food Deutschland e.V.</h2>
            </a>
        </div>
        <div class="border-b text-grey border-neutral-700 py-14">
            <div class="flex flex-col lg:flex-row flex-wrap justify-between gap-20">
                <div class="flex flex-col gap-5">
                    <h2 class="font-cinzel uppercase text-primary tracking-widest">{$t('shop.footer.contact')}</h2>
                    <div class="flex flex-col text-[0.9375rem] gap-2">
                        <a href="mailto:office@vanvolxem.com" class="text-chamois hover:text-white transition-colors"
                            >office@vanvolxem.com</a
                        >
                        <a href="tel:+496501802290" class="text-chamois hover:text-white transition-colors"
                            >+49 6501-80229-0</a
                        >
                    </div>
                    <div class="flex flex-col text-[0.9375rem] gap-2">
                        <p class="font-medium">{$t('shop.footer.winery')} Van Volxem</p>
                        <p>Zum Schlossberg 347</p>
                        <p>54459 Wiltingen / Saar</p>
                    </div>
                    <div class="flex flex-col text-[0.9375rem] gap-2">
                        <p class="font-medium">{$t('shop.footer.wine-shop-opening')}</p>
                        <p>{$t('shop.footer.days')}</p>
                        <p>11:00 – 18:00 {$t('shop.footer.clock')}</p>
                    </div>
                </div>
                <div class="flex flex-col gap-5 text-[0.9375rem]">
                    <h2 class="font-cinzel text-primary uppercase tracking-widest text-base">
                        {$t('shop.footer.information')}
                    </h2>
                    <a href="/{lang}/agb#shipping" class="hover:text-neutral-300 transition-colors"
                        >Versand & Rückversand</a
                    >
                    <a href="/{lang}/agb#payment" class="hover:text-neutral-300 transition-colors"
                        >Zahlungsinformationen</a
                    >
                    <a href="/{lang}/agb" class="hover:text-neutral-300 transition-colors">AGB</a>
                    <a href="/{lang}/agb#revocation" class="hover:text-neutral-300 transition-colors"
                        >Widerrufsbelehrung</a
                    >
                    <a href="/{lang}/privacy" class="hover:text-neutral-300 transition-colors">Datenschutzerklärung</a>
                    <a href="/{lang}/impressum" class="hover:text-neutral-300 transition-colors">Impressum</a>
                </div>
                <div class="flex flex-col gap-5">
                    <h2 class="font-cinzel uppercase text-primary tracking-widest">{$t('shop.footer.awards')}</h2>
                    <p>
                        {$t('shop.footer.awards-details.1st')}<br />2023/2024<br /><span class="text-[0.9375rem]"
                            >wein.plus 2024</span
                        >
                    </p>
                    <p>
                        {$t('shop.footer.awards-details.2nd')}<br /><span class="text-[0.9375rem]"
                            >Der Feinschmecker 2023</span
                        >
                    </p>
                    <p>{$t('shop.footer.awards-details.3rd')}<br /><span class="text-[0.9375rem]">Vinum 2019</span></p>
                    <p>
                        ★★★-{$t('shop.footer.awards-details.4th')}<br /><span class="text-[0.9375rem]"
                            >Wein-Plus 2018</span
                        >
                    </p>
                    <p>
                        {$t('shop.footer.awards-details.5th')}<br /><span class="text-[0.9375rem]">Falstaff 2012</span>
                    </p>
                </div>
                <div class="flex flex-col gap-5">
                    <h2 class="font-cinzel uppercase text-primary tracking-widest">Begleite uns</h2>
                    <div class="flex flex-col gap-3.5 font-light">
                        <a
                            href="https://www.instagram.com/van_volxem/"
                            target="_blank"
                            class="uppercase text-[1.75rem] tracking-widest flex items-center gap-5 hover:text-neutral-300 transition-colors"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="23"
                                viewBox="0 0 22 23"
                                fill="currentColor"
                            >
                                <path
                                    d="M10.9584 2.60641C13.863 2.60641 14.2591 2.60641 15.4474 2.60641C16.5036 2.60641 17.0317 2.87047 17.4278 3.0025C17.9559 3.26656 18.352 3.39859 18.7481 3.79467C19.1442 4.19076 19.4083 4.58685 19.5403 5.11496C19.6723 5.51105 19.8044 6.03917 19.9364 7.0954C19.9364 8.28366 19.9364 8.54772 19.9364 11.5844C19.9364 14.6211 19.9364 14.8851 19.9364 16.0734C19.9364 17.1296 19.6723 17.6577 19.5403 18.0538C19.2762 18.5819 19.1442 18.978 18.7481 19.3741C18.352 19.7702 17.9559 20.0342 17.4278 20.1663C17.0317 20.2983 16.5036 20.4303 15.4474 20.5624C14.2591 20.5624 13.9951 20.5624 10.9584 20.5624C7.92174 20.5624 7.65768 20.5624 6.46942 20.5624C5.41319 20.5624 4.88507 20.2983 4.48899 20.1663C3.96087 19.9022 3.56478 19.7702 3.1687 19.3741C2.77261 18.978 2.50855 18.5819 2.37652 18.0538C2.24449 17.6577 2.11246 17.1296 1.98044 16.0734C1.98044 14.8851 1.98044 14.6211 1.98044 11.5844C1.98044 8.54772 1.98044 8.28366 1.98044 7.0954C1.98044 6.03917 2.24449 5.51105 2.37652 5.11496C2.64058 4.58685 2.77261 4.19076 3.1687 3.79467C3.56478 3.39859 3.96087 3.13453 4.48899 3.0025C4.88507 2.87047 5.41319 2.73844 6.46942 2.60641C7.65768 2.60641 8.05377 2.60641 10.9584 2.60641ZM10.9584 0.625977C7.92174 0.625977 7.65768 0.625977 6.46942 0.625977C5.28116 0.625977 4.48899 0.890035 3.82884 1.15409C3.1687 1.41815 2.50855 1.81424 1.84841 2.47438C1.18826 3.13453 0.924204 3.66264 0.528117 4.45482C0.264059 5.11496 0.132029 5.90714 0 7.0954C0 8.28366 0 8.67975 0 11.5844C0 14.6211 0 14.8851 0 16.0734C0 17.2616 0.264059 18.0538 0.528117 18.714C0.792175 19.3741 1.18826 20.0342 1.84841 20.6944C2.50855 21.3545 3.03667 21.6186 3.82884 22.0147C4.48899 22.2787 5.28116 22.4108 6.46942 22.5428C7.65768 22.5428 8.05377 22.5428 10.9584 22.5428C13.863 22.5428 14.2591 22.5428 15.4474 22.5428C16.6357 22.5428 17.4278 22.2787 18.088 22.0147C18.7481 21.7506 19.4083 21.3545 20.0684 20.6944C20.7286 20.0342 20.9926 19.5061 21.3887 18.714C21.6528 18.0538 21.7848 17.2616 21.9168 16.0734C21.9168 14.8851 21.9168 14.489 21.9168 11.5844C21.9168 8.67975 21.9168 8.28366 21.9168 7.0954C21.9168 5.90714 21.6528 5.11496 21.3887 4.45482C21.1246 3.79467 20.7286 3.13453 20.0684 2.47438C19.4083 1.81424 18.8801 1.55018 18.088 1.15409C17.4278 0.890035 16.6357 0.758006 15.4474 0.625977C14.2591 0.625977 13.9951 0.625977 10.9584 0.625977Z"
                                />
                                <path
                                    d="M10.9584 5.90714C7.78971 5.90714 5.28116 8.41569 5.28116 11.5844C5.28116 14.7531 7.78971 17.2616 10.9584 17.2616C14.1271 17.2616 16.6357 14.7531 16.6357 11.5844C16.6357 8.41569 14.1271 5.90714 10.9584 5.90714ZM10.9584 15.2812C8.97797 15.2812 7.2616 13.6968 7.2616 11.5844C7.2616 9.60395 8.84594 7.88757 10.9584 7.88757C12.9388 7.88757 14.6552 9.47192 14.6552 11.5844C14.6552 13.5648 12.9388 15.2812 10.9584 15.2812Z"
                                />
                                <path
                                    d="M16.7677 7.0954C17.4969 7.0954 18.088 6.50429 18.088 5.77511C18.088 5.04593 17.4969 4.45482 16.7677 4.45482C16.0385 4.45482 15.4474 5.04593 15.4474 5.77511C15.4474 6.50429 16.0385 7.0954 16.7677 7.0954Z"
                                />
                            </svg>
                            Instagram
                        </a>
                        <a
                            href="https://www.facebook.com/vanvolxemwines/"
                            target="_blank"
                            class="uppercase text-[1.75rem] tracking-widest flex items-center gap-5 hover:text-neutral-300 transition-colors"
                            ><svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="21"
                                height="20"
                                viewBox="0 0 21 20"
                                fill="currentColor"
                            >
                                <path
                                    d="M20.4589 9.78525C20.4589 4.40343 16.0556 0.00012207 10.6738 0.00012207C5.29198 0.00012207 0.888672 4.40343 0.888672 9.78525C0.888672 14.6778 4.43578 18.7142 9.08371 19.4481V12.5985H6.63743V9.78525H9.08371V7.58359C9.08371 5.13731 10.5515 3.79186 12.7531 3.79186C13.854 3.79186 14.9548 4.03649 14.9548 4.03649V6.48277H13.7316C12.5085 6.48277 12.1416 7.21665 12.1416 7.95054V9.78525H14.8325L14.3432 12.5985H12.0193V19.5704C16.9118 18.8365 20.4589 14.6778 20.4589 9.78525Z"
                                />
                            </svg>
                            Facebook
                        </a>
                        <a
                            href="https://www.linkedin.com/company/van-volxem/"
                            target="_blank"
                            class="uppercase text-[1.75rem] tracking-widest flex items-center gap-5 hover:text-neutral-300 transition-colors"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="currentColor"
                            >
                                <path
                                    d="M4.49151 18.0001H0.879001V5.96262H4.49151V18.0001ZM2.68526 4.27512C1.51651 4.27512 0.666504 3.37512 0.666504 2.13762C0.666504 0.900122 1.62276 0.00012207 2.68526 0.00012207C3.85401 0.00012207 4.70401 0.900122 4.70401 2.13762C4.70401 3.37512 3.85401 4.27512 2.68526 4.27512ZM17.6665 18.0001H14.054V11.4751C14.054 9.56262 13.3102 9.00012 12.2477 9.00012C11.1852 9.00012 10.1227 9.90012 10.1227 11.5876V18.0001H6.51025V5.96262H9.91025V7.65012C10.229 6.86262 11.504 5.62512 13.3102 5.62512C15.329 5.62512 17.454 6.86262 17.454 10.5751V18.0001H17.6665Z"
                                />
                            </svg>
                            Linked in
                        </a>
                        <a
                            href="https://www.tiktok.com/@van_volxem"
                            target="_blank"
                            class="uppercase text-[1.75rem] tracking-widest flex items-center gap-5 hover:text-neutral-300 transition-colors"
                        >
                            <svg
                                width="19"
                                height="21"
                                viewBox="0 0 19 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.56456 7.95773C3.56138 8.75651 2.02745 10.4894 1.50315 12.6172C1.80777 10.3754 3.43343 8.55102 5.56456 7.95773ZM4.82085 13.2371C4.88381 12.2027 5.64404 11.3537 6.63507 11.1555C5.77104 11.5577 5.104 12.3141 4.82085 13.2371ZM9.57302 19.6606C11.5777 18.8603 13.1111 17.1254 13.6352 14.9983C13.3306 17.2391 11.7041 19.0638 9.57302 19.6606ZM8.50948 16.4542C9.36583 16.0542 10.0281 15.3056 10.3139 14.3926C10.2438 15.4151 9.49007 16.2545 8.50948 16.4542Z"
                                    stroke="currentColor"
                                    stroke-opacity="0.5"
                                    stroke-width="1.125"
                                />
                                <path
                                    d="M13.2682 13.3805V6.54025C14.5852 7.48563 16.2018 8.04463 17.9456 8.04463V5.43128C16.9375 5.21771 16.0519 4.67229 15.398 3.92234C14.3444 3.23608 13.5861 2.13618 13.3454 0.854492H10.8841L10.8795 14.3394C10.8251 15.8484 9.58075 17.0619 8.05951 17.0619C7.11492 17.0619 6.28388 16.5938 5.76619 15.8848C4.86704 15.4075 4.24944 14.4668 4.24944 13.3805C4.24944 11.8216 5.51643 10.5535 7.07405 10.5535C7.36468 10.5535 7.64623 10.6035 7.90963 10.6853V8.04918C4.56733 8.12191 1.86987 10.8671 1.86987 14.2349C1.86987 15.862 2.5011 17.3437 3.53194 18.4527C4.53553 19.1572 5.76165 19.5753 7.07859 19.5753C10.489 19.5753 13.2682 16.7938 13.2682 13.3805Z"
                                    fill="currentColor"
                                />
                            </svg>
                            Tiktok
                        </a>
                    </div>
                </div>
                <div class="flex flex-col gap-20">
                    <div class="flex flex-col gap-5">
                        <h2 class="font-cinzel uppercase text-primary tracking-widest">Sprachauswahl</h2>
                        <LanguageSelection />
                    </div>
                    <div class="flex flex-col gap-5">
                        <h2 class="font-cinzel uppercase text-primary tracking-widest">Zahlungsmethoden</h2>
                        <div class="grid grid-cols-2 gap-5">
                            {#each paymentMethods ?? [] as paymentMethod}
                                <div class="flex gap-3 items-center text-[0.9375rem]">
                                    {#if paymentMethod.media?.url}
                                        <img src={paymentMethod.media.url} alt={paymentMethod.translated.name} />
                                    {:else}
                                        <div class="w-8 h-6" />
                                    {/if}
                                    <p class="text-[0.9375rem]">{paymentMethod.translated.name}</p>
                                </div>
                            {/each}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-col lg:flex-row justify-between text-[0.9375rem] *:mt-6">
            <p>
                © {currentYear} Van Volxem.
                <a
                    href="https://lewo-media.de"
                    class="inline-flex gap-1 justify-center lg:justify-start items-center order-2 lg:order-1 pb-5 lg:pb-0 pt-4 lg:pt-0 hover:text-neutral-400 transition-colors"
                >
                    Made with
                    <span class="mx-0.5"><HeartIcon /></span>
                    by LEWO.
                </a>
            </p>
            <div class="flex flex-wrap gap-x-16 gap-y-5 order-1 lg:order-2">
                <a href="/{lang}/agb" class="hover:text-neutral-400 transition-colors">AGB</a>
                <a href="/" class="hover:text-neutral-400 transition-colors">Cookies</a>
                <a href="/{lang}/privacy" class="hover:text-neutral-400 transition-colors">Datenschutzerklärung</a>
                <a href="/{lang}/impressum" class="hover:text-neutral-400 transition-colors">Impressum</a>
            </div>
        </div>
    </div>
</div>
